import PropTypes from 'prop-types';

const DialogPropType = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default DialogPropType;
